module.exports = __webpack_public_path__ + "img/42600.919da702.jpg";